// Known Sunday used as base date for generating weekday names.
// Pikaday requires weekdays ordered Sunday-first.
const BASE_SUNDAY = new Date(2024, 6, 7); // July 7, 2024 is a Sunday

export function createDatepickerConfig(intl) {
  const months = Array.from({ length: 12 }, (_, i) =>
    intl.formatDate(new Date(2024, i, 1), { month: 'long' })
  );

  const weekdays = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(BASE_SUNDAY);
    d.setDate(BASE_SUNDAY.getDate() + i);
    return intl.formatDate(d, { weekday: 'long' });
  });

  const weekdaysShort = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(BASE_SUNDAY);
    d.setDate(BASE_SUNDAY.getDate() + i);
    return intl.formatDate(d, { weekday: 'short' });
  });

  return {
    previousMonth: intl.formatMessage({
      defaultMessage: 'Last Month',
    }),
    nextMonth: intl.formatMessage({
      defaultMessage: 'Next Month',
    }),
    months,
    weekdays,
    weekdaysShort,
  };
}
